/**
 * Permissões do grupo "Faixa de cobrança" (aba "Faixas" em
 * /dashboard/settings?tab=billing). Espelha
 * Domain.Security.Permissions.BillingRangeFeatures do NotiifyMe — o backend
 * checa as mesmas chaves nos endpoints de escrita, então o gating daqui é
 * conveniência de UX (não mostrar o que voltaria 403), nunca a barreira de
 * segurança.
 *
 * Exceção: `read`. O GET de faixas também alimenta o filtro de faixa do
 * dashboard/relatórios e a barra de faixas da importação de planilha, então
 * ele não é gateado no backend — aqui `read` decide apenas se a aba
 * "Faixas" aparece.
 */
export const BillingRangeFeatures = {
  read: "read:billing-range",
  create: "create:billing-range",
  delete: "delete:billing-range",
  updateStatus: "update_status:billing-range",
  updateDays: "update_days:billing-range",
  updateTemplate: "update_template:billing-range",
  updateDescription: "update_description:billing-range",
  updatePriority: "update_priority:billing-range",
  /** Billing results page (/dashboard/billing-results); enforced by the API too. */
  readResult: "read:billing-range:result",
  /** Billing queue page (/dashboard/billing-queue); enforced by the API too. */
  readQueue: "read:billing-range:queue",
} as const;
